import Http from "@/commons/Http";

const path = 'api/financeiro/nota-fiscal';

export default {

  async getByProtocolo(protocoloId) {
    return Http.get(`${path}/protocolo/${protocoloId}/financeiro`);
  },

  async getById(id){
    return Http.get(`${path}/${id}`);
  },

  async pagination(sort, direction, page, size, filters = {}){
    return Http.post(`${path}/pagination?sort=${sort || 'n.rps'},${direction || 'asc'}&page=${page || 1}&size=${size || 10}`, filters);
  },

  async alterarStatus(notaFiscalId){
    return Http.post(`${path}/set-pendente/${notaFiscalId}`);
  },

  async gerarNotaFiscal(protocoloId) {
    return Http.get(`${path}/gerar-nota/${protocoloId}`);
  },

  async emitirNotasPendentes() {
    return Http.get(`${path}/processar-notas-pendentes`);
  },

  async gerarNotasPendentes() {
    return Http.get(`${path}/gerar-notas-pendentes`);
  },

  async consultarNotas(ids = []) {
    return Http.post(`${path}/consultar-notas`, ids);
  },

  async processarNotaFiscal(notaFiscalId) {
    return Http.get(`${path}/processar-nota/${notaFiscalId}`);
  },

  async consultarNotaFiscal(notaFiscalId) {
    return Http.get(`${path}/consultar-nota/${notaFiscalId}`);
  },

  async validacaoCancelamentoPorAPI() {
    return Http.get(`${path}/cancelamento-por-api`);
  },

  async cancelarNotaFiscal(notaFiscalId, justificativa){
    return Http.post(`${path}/cancelar/${notaFiscalId}`, { justificativa });
  },

  async enviarParaFilaEmissaoEmLote(ids) {
    return Http.post(`${path}/set-pendente-em-lote`, ids);
  },

  async cancelarNotasFiscaisEmLote(ids, justificativa) {
    return Http.post(`${path}/cancelar-em-lote`, { ids, justificativa });
  },

  async getProvider() {
    return Http.get(`${path}/provider`);
  },

  async getUrlPdfPrefeitura(id) {
    return Http.get(`${path}/pdf-prefeitura/${id}`);
  },

  async substituirNotaFiscal(id, dados) {
    return Http.post(`${path}/substituir-nota/${id}`, dados);
  },

  async atualizarNotaFiscal(id, dados) {
    return Http.post(`${path}/atualizar-nota/${id}`, dados);
  },

  async save(dto, id = ''){
    return Http.post(`${path}/${id}`, dto);
  },

  async salvarNomeTomador(dto, id){
    return Http.post(`${path}/${id}/nome-tomador`, dto);
  },

  async getXML(notaFiscalId){
    return Http.get(`${path}/gerar-xml/${notaFiscalId}`)
  },

  async alterarStatusEmissao(id, emitida) {
    return Http.post(`${path}/emissao-manual/${id}?emitida=${emitida}`);
  },

  async marcarComoEmitidaEmLote(ids) {
    return Http.post(`${path}/emissao-manual-em-lote`, ids);
  },

  getNaturezasDeOperacao(){
    return [
      {id: "TRIBUTACAO_NO_MUNICIPIO", nome: "1 - Tributação no município"},
      {id: "TRIBUTACAO_FORA_DO_MUNICIPIO", nome: "2 - Tributação fora do município"},
      {id: "ISENCAO", nome: "3 - Isenção"},
      {id: "IMUNE", nome: "4 - Imune"},
      {id: "EXIGIBILIDADE_SUSPENSA_POR_DECISAO_JUDICIAL", nome: "5 - Exigibilidade suspensa por decisão judicial"},
      {id: "EXIGIBILIDADE_SUSPENSA_POR_PROCEDIMENTO_ADMINISTRATIVO", nome: "6 - Exigibilidade suspensa por procedimento administrativo"},
      {id: "EXIGIVEL", nome: "7 - Exigível"},
      {id: "NAO_INCIDENCIA", nome: "8 - Não incidência"},
      {id: "EXPORTACAO", nome: "9 - Exportação"},
      {id: "ISS_FIXO", nome: "10 - ISS fixo"},
      {id: "SUBSTITUICAO_TRIBUTARIA", nome: "11 - Substituição tributária"},
      {id: "SIMPLES_NACIONAL", nome: "12 - Simples Nacional"},
      {id: "ISENCAO_PARCIAL", nome: "13 - Isenção parcial"},
      {id: "CANCELADO", nome: "14 - Cancelado"},
      {id: "ISS_RETIDO_PELO_TOMADORINTERMEDIARIO", nome: "15 - ISS retido pelo tomador/intermediário"},
      {id: "NAO_TRIBUTAVEL", nome: "16 - Não tributável"},
      {id: "MICRO_EMPREENDEDOR_INDIVIDUAL_MEI", nome: "17 - Micro Empreendedor Individual 'MEI'"},
      {id: "SERVICO_PARA_IMOVEL_CONSTRUCAO_CIVIL", nome: "18 - Serviço para imóvel 'Construção Civil'"},
      {id: "SERVICO_EM_VIA_PUBLICA", nome: "19 - Serviço em via pública"},
      {id: "TRIBUTADA_INTEGRALMENTE_COM_ISSRF", nome: "20 - Tributada integralmente com ISSRF"},
      {id: "TRIBUTADA_COM_REDUCAO_DA_BASE_DE_CALCULO", nome: "21 - Tributada com redução da base de cálculo"},
      {id: "TRIBUTADA_COM_REDUCAO_DA_BASE_DE_CALCULO_COM_ISSRF", nome: "22 - Tributada com redução da base de cálculo com ISSRF"},
      {id: "TRIBUTADA_COM_REDUCAO_DA_BASE_DE_CALCULO_COM_SUB_TRIBUTARIA", nome: "23 - Tributada com redução da base de cálculo com Sub. Tributária"},
      {id: "NAO_TRIBUTADA_ISS_REGIME_ESTIMATIVA", nome: "24 - Não tributada - ISS regime estimativa"},
      {id: "NAO_TRIBUTADA_ISS_CONSTRUCAO_CIVIL_RECOLHIDO_ANTECIPADAMENTE", nome: "25 - Não Tributada - ISS construção civil recolhido antecipadamente"},
      {id: "NAO_TRIBUTADA_ATO_COOPERADO", nome: "26 - Não Tributada - Ato Cooperado"},
      {id: "SIMPLES_NACIONAL_E_COM_O_ISS_RETIDO_NA_FONTE", nome: "27 - Simples Nacional e com o ISS retido na fonte"},
      {id: "SUBSTITUICAO_TRIBUTARIA_PELO_AGENCIADOR_OU_INTERMEDIARIO_DA_PRESTACAO_DO_SERVICO", nome: "28 - Substituição tributária pelo agenciador ou intermediário da prestação do serviço"},
      {id: "SIMPLES_NACIONAL_E_SUBSTITUICAO_TRIBUTARIA", nome: "29 - Simples Nacional e substituição tributária"},
      {id: "ISSRETIDOANTERIORMENTESUBSTITUTOTRIBUTARIO", nome: "30 - ISSRetidoAnteriormenteSubstitutoTributario"},
      {id: "TRIBUTADA_COM_REDUCAO_DA_BASE_DE_CALCULO_OU_ALIQUOTA_E_COM_ISS_RETIDO_NA_FONTE", nome: "31 - Tributada com redução da base de cálculo ou alíquota e com ISS retido na fonte"},
      {id: "TRIBUTADA_COM_REDUCAO_DA_BASE_DE_CALCULO_OU_ALIQUOTA_E_SUJEITA_AO_REGIME_DA_SUBSTITUICAO_TRIBUTARIA", nome: "32 - Tributada com reducao da base de cálculo ou alíquota e sujeita ao regime da substituicao tributária"},
      {id: "TRIBUTADA_COM_REDUCAO_DA_BASE_DE_CALCULO_OU_ALIQUOTA_E_COM_O_ISS_RETIDO_ANTERIORMENTE_PELO_SUBSTITUTO_TRIBUTARIO", nome: "33 - Tributada com reducao da base de cálculo  ou aliquota e com o ISS retido anteriormente pelo substituto tributário"},
      {id: "NAO_TRIBUTADA_EM_RAZAO_DO_DESTINO_DOS_BENS_OU_OBJETOS_MERCADORIAS_PARA_A_INDUSTRIALIZACAO_OU_COMERCIALIZACAO", nome: "34 - Nao tributada em razao do destino dos bens ou objetos - Mercadorias para a industrializacao ou comercializacao"},
      {id: "NAO_TRIBUTADA_EM_RAZAO_DO_DIFERIMENTO_DA_PRESTACAO_DO_SERVICO", nome: "35 - Nao tributada em razao do diferimento da prestacao do servico"},
      {id: "TRIBUTADO_NO_MUNICIPIO_POREM_ISENTO", nome: "36 - Tributado no município, porém Isento"},
      {id: "TRIBUTADO_FORA_DO_MUNICIPIO_POREM_ISENTO", nome: "37 - Tributado Fora do município, porém Isento"},
      {id: "TRIBUTADO_NO_MUNICIPIO_POREM_IMUNE", nome: "38 - Tributado no município, porém Imune"},
      {id: "TRIBUTADO_FORA_DO_MUNICIPIO_POREM_IMUNE", nome: "39 - Tributado Fora do município, porém Imune"},
      {id: "TRIBUTADO_NO_MUNICIPIO_POREM_EXIGIBILIDADE_SUSPENSA", nome: "40 - Tributado no município, porém Exigibilidade Suspensa"},
      {id: "TRIBUTADO_FORA_DO_MUNICIPIO_POREM_EXIGIBILIDADE_SUSPENSA", nome: "41 - Tributado Fora do município, porém Exigibilidade Suspensa"},
      {id: "TRATAMENTO_FISCAL_DIFERENCIADO", nome: "42 - Tratamento Fiscal Diferenciado"},
      {id: "ESTIMADO", nome: "43 - Estimado"},
      {id: "IMPOSTO_DEVIDO_NO_MUNICIPIO_COM_RETENCAO_NA_FONTE_SERVICO_PRESTADO_NO_MUNICIPIO", nome: "51 - Imposto devido no município, com retenção na fonte 'serviço prestado no município'"},
      {id: "IMPOSTO_DEVIDO_NO_MUNICIPIO_SEM_RETENCAO_NA_FONTE_SERVICO_PRESTADO_NO_MUNICIPIO", nome: "52 - Imposto devido no município, sem retenção na fonte 'serviço prestado no município'"},
      {id: "NAO_TRIBUTAVEL_SERVICO_PRESTADO_NO_MUNICIPIO", nome: "58 - Não tributável 'serviço prestado no município'"},
      {id: "SIMPLES_NACIONAL_SERVICO_PRESTADO_NO_MUNICIPIO", nome: "59 - Simples Nacional 'serviço prestado no município'"},
      {id: "IMPOSTO_DEVIDO_NO_MUNICIPIO_COM_RETENCAO_NA_FONTE_SERVICO_PRESTADO_FORA_DO_MUNICIPIO", nome: "61 - Imposto devido no município, com retenção na fonte 'serviço prestado fora do município'"},
      {id: "IMPOSTO_DEVIDO_NO_MUNICIPIO_SEM_RETENCAO_NA_FONTE_SERVICO_PRESTADO_FORA_DO_MUNICIPIO", nome: "62 - Imposto devido no município, sem retenção na fonte 'serviço prestado fora do município'"},
      {id: "IMPOSTO_DEVIDO_FORA_DO_MUNICIPIO_COM_RETENCAO_NA_FONTE_SERVICO_PRESTADO_FORA_DO_MUNICIPIO", nome: "63 - Imposto devido fora do município, com retenção na fonte 'serviço prestado fora do município'"},
      {id: "IMPOSTO_DEVIDO_FORA_DO_MUNICIPIO_SEM_RETENCAO_NA_FONTE_SERVICO_PRESTADO_FORA_DO_MUNICIPIO", nome: "64 - Imposto devido fora do município, sem retenção na fonte 'serviço prestado fora do município'"},
      {id: "NAO_TRIBUTAVEL_SERVICO_PRESTADO_FORA_DO_MUNICIPIO", nome: "68 - Não tributável 'serviço prestado fora do município'"},
      {id: "SIMPLES_NACIONAL_SERVICO_PRESTADO_FORA_DO_MUNICIPIO", nome: "69 - Simples Nacional 'serviço prestado fora do Município'"},
      {id: "NAO_TRIBUTAVEL_SERVICO_PRESTADO_NO_EXTERIOR", nome: "78 - Não tributável 'serviço prestado no exterior'"},
      {id: "ISS_DEVIDO_PARA_O_MUNICIPIO_SIMPLES_NACIONAL", nome: "501 - ISS devido para o município 'Simples Nacional'"},
      {id: "ISS_DEVIDO_PARA_OUTRO_MUNICIPIO_SIMPLES_NACIONAL", nome: "502 - ISS devido para outro município 'Simples Nacional'"},
      {id: "SERVICO_NO_MUNICIPIO_ISS_MENSAL_SEM_RETENCAO_NA_FONTE", nome: "511 - Serviço no município - ISS mensal sem retenção na fonte"},
      {id: "SERVICO_NO_MUNICIPIO_ISS_MENSAL_COM_RETENCAO_NA_FONTE", nome: "512 - Serviço no município - ISS mensal com retenção na fonte"},
      {id: "CONSTRUCAO_CIVIL_NO_MUNICIPIO_ISS_MENSAL_SEM_RETENCAO_NA_FONTE", nome: "521 - Construção civil - no município - ISS mensal sem retenção na fonte"},
      {id: "CONSTRUCAO_CIVIL_NO_MUNICIPIO_ISS_MENSAL_COM_RETENCAO_NA_FONTE", nome: "522 - Construção civil - no município - ISS mensal com retenção na fonte"},
      {id: "ESCRITORIO_CONTABIL_SIMPLES_NACIONAL", nome: "551 - Escritório Contábil 'Simples Nacional'"},
      {id: "ISS_RETIDO_PELO_TOMADORINTERMEDIARIO_SIMPLES_NACIONAL", nome: "601 - ISS retido pelo tomador/intermediário 'Simples Nacional'"},
      {id: "SERVICO_EM_OUTRO_MUNICIPIO_ISS_MENSAL_SEM_RETENCAO_NA_FONTE", nome: "611 - Serviço em outro município – ISS mensal sem retenção na fonte"},
      {id: "SERVICO_EM_OUTRO_MUNICIPIO_ISS_MENSAL_COM_RETENCAO_NA_FONTE", nome: "612 - Serviço em outro município – ISS mensal com retenção na fonte"},
      {id: "CONSTRUCAO_CIVIL_OUTRO_MUNICIPIO_ISS_MENSAL_SEM_RETENCAO_NA_FONTE", nome: "621 - Construção civil - outro município - ISS mensal sem retenção na fonte"},
      {id: "CONSTRUCAO_CIVIL_OUTRO_MUNICIPIO_ISS_MENSAL_COM_RETENCAO_NA_FONTE", nome: "622 - Construção civil - outro município - ISS mensal com retenção na fonte"},
      {id: "OPERACAO_IMUNE_ISENTA_OU_NAO_TRIBUTADA_SIMPLES_NACIONAL", nome: "701 - Operação imune, isenta ou não tributada 'Simples Nacional'"},
      {id: "SERVICO_NAO_ENQUADRADA_NAS_SITUACOES_ANTERIORES_SEM_RETENCAO", nome: "911 - Serviço não enquadrada nas situações anteriores - sem retenção"},
      {id: "SERVICO_NAO_ENQUADRADA_NAS_SITUACOES_ANTERIORES_COM_RETENCAO", nome: "912 - Serviço não enquadrada nas situações anteriores - com retenção"}
    ]
  },

  getSituacaoNota(){
    return [
      {id: "PENDENTE", nome: "Pendente"},
      {id: "PROCESSANDO", nome: "Processando"},
      {id: "EMITIDA", nome: "Emitida"},
      {id: "CANCELADA", nome: "Cancelada"},
      {id: "VERIFICAR", nome: "Verificar"},
      {id: "REPROCESSAR", nome: "Reprocessar"},
      {id: "SUBSTITUIDA", nome: "Substituída"},
      {id: "EMISSAO_CANCELADA", nome: "Emissão Cancelada"},
    ]
  },

  getLabelAjudaFormaCalculoIss(formaCalculoIss, exibirFormatado = true) {
    const textos = {
      PADRAO: `
      Aplica o percentual de ISS diretamente sobre a base de incidência.<br><br>

      <strong>Fórmula:</strong><br>
      ISS = Base do ISS × percentual`,

      POR_DENTRO: `
      Calcula o ISS de forma que o valor repassado à Prefeitura corresponda exatamente ao percentual configurado,
      evitando efeito cascata e distorções por reaplicação do percentual.<br><br>

      <strong>Fórmulas:</strong><br>
      y = (100 − percentual) ÷ 100<br>
      ISS final = (Base do ISS × percentual) ÷ y<br><br>

      <strong>Exemplos:</strong><br>
      ISS de 5% → divisor 0,95<br>
      ISS de 2% → divisor 0,98
    `
    }

    let texto = textos[formaCalculoIss] || textos.POR_DENTRO;

    if (!exibirFormatado) {
      // Remove tags HTML e espaços em branco para evitar que sejam exibidas no tooltip
      texto = texto.replace(/<[^>]*>/g, '');
      texto = texto.split('\n').map(line => line.trimStart()).join('\n');
      texto = texto.replace(/^\s*\n/, '');
    }
    return texto;
  }

}
